import { render, staticRenderFns } from "./Laboratory.vue?vue&type=template&id=e4544aa2&scoped=true&"
import script from "./Laboratory.vue?vue&type=script&lang=js&"
export * from "./Laboratory.vue?vue&type=script&lang=js&"
import style0 from "./Laboratory.vue?vue&type=style&index=0&id=e4544aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4544aa2",
  null
  
)

export default component.exports